import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

const PositionBadges = ({ positions }) => {
  if (!positions.length) return "—";

  const ordered = [...positions].sort((a, b) => Number(b.primary) - Number(a.primary));
  return (
    <div className="d-flex flex-wrap" style={{ gap: 4 }}>
      {ordered.map((position) => (
        <React.Fragment key={position.id}>
          <Badge color={position.color_hex || "gray"} type={position.color_hex ? "pill-outline" : "pill-color"} size="sm" dot={Boolean(position.color_hex)}>
            {position.name}
          </Badge>
          {position.volunteer && (
            <Badge color="purple" size="sm">
              Volunteer
            </Badge>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

PositionBadges.propTypes = {
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      volunteer: PropTypes.bool.isRequired,
      primary: PropTypes.bool,
      color_hex: PropTypes.string,
    })
  ).isRequired,
};

export default PositionBadges;
